import { BaseController } from '../../../../../../../common/base/controller';
import { MODEL_FIELDS } from '../../createRequest.model';

const ADDITIONAL_ACCOUNT_OWNERS_FIELD = MODEL_FIELDS.additionalAccountOwners;

export class PersonController extends BaseController {
  constructor($scope, $compile, controllerService) {
    'ngInject';
    super({
      $scope,
      $compile,
      controllerService,
    });
  }

  getLabelFor(field) {
    return 'receiving.createRequest.form.' + this.prefix + field;
  }

  addAdditionalAccountOwners() {
    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    if (this.model[this.prefix + field].length >= 3) {
      return;
    }
    this.model[this.prefix + field].push({
      [MODEL_FIELDS.firstName]: '',
      [MODEL_FIELDS.lastName]: '',
    });
  }

  removeAdditionalAccountOwner(index) {
    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    this.model[this.prefix + field].splice(index, 1);
  }

  $onInit() {
    this.prefix = this.prefix || '';
    this.MODEL_FIELDS = MODEL_FIELDS;
    this.showCountry = (this.envService.countryCode || 'DE') !== 'DE';

    if (!this.model[MODEL_FIELDS.country]) {
      this.model[MODEL_FIELDS.country] = this.envService.countryCode || 'DE';
    }

    this.countryOptions = {
      modelKey: 'key',
      orderKeys: false,
      searchEnabled: false,
      selectables: [
        { key: 'DE', value: 'app.card.section.address.country.DE' },
        { key: 'AT', value: 'app.card.section.address.country.AT' },
        { key: 'CH', value: 'app.card.section.address.country.CH' },
      ],
    };

    const field = ADDITIONAL_ACCOUNT_OWNERS_FIELD;
    if (!this.model[this.prefix + field]) {
      this.model[this.prefix + field] = [];
    }

    this.birthdayMessages = {
      parse: `receiving.createRequest.form.error.invalid.${MODEL_FIELDS.birthday}`,
      required: `receiving.createRequest.form.error.required.${this.prefix}${MODEL_FIELDS.birthday}`,
    };
  }
}
